import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31de8220"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  style: {"width":"3rem","height":"3rem"},
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Cargando...")
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_5 = {
  key: 2,
  class: "alert alert-secondary",
  role: "alert"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "Muy pronto, verás publicados mis pensamientos en esta sección.", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "row justify-content-between text-center" }
const _hoisted_9 = { class: "col col-lg-4 text-start" }
const _hoisted_10 = { class: "col col-lg-4 text-end" }
const _hoisted_11 = { class: "row justify-content-between text-center" }
const _hoisted_12 = { class: "col col-lg-4 text-start" }
const _hoisted_13 = { class: "col col-lg-4 text-end" }

import { ref, onMounted, Ref } from 'vue'
import Resource from '@/data/tools/Resource'
import { Thought } from '@/data/models/Thought'
import ThoughtDao from '@/data/dao/ThoughtDao'
import ThoughtComponent from '@/views/thoughts/components/ThoughtComponent.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ThoughtPage',
  setup(__props) {

const t = new ThoughtDao()

const thoughts: Ref<Array<Thought>> = ref([])

const firstThought: Ref<Thought | null> = ref(null)
const lastThought: Ref<Thought | null> = ref(null)

const showBackButton = ref(false)
const showNextButton = ref(false)
const loading = ref(false)
const error = ref(false)

function checkButton(){
  if(thoughts.value.length > 0){
    (thoughts.value[0].id === firstThought.value?.id) ? showBackButton.value = false : showBackButton.value = true,
    (thoughts.value[thoughts.value.length - 1].id === lastThought.value?.id) ? showNextButton.value = false : showNextButton.value = true
  }else{
    showBackButton.value = false
    showNextButton.value = false
  }
}

async function getThoughts(){
  await t.getThoughts((resource: Resource) => {
    switch (resource.status) {
      case Resource.LOADING:
        loading.value = true
        break
      case Resource.ERROR:
        error.value = true
        loading.value = false
        break
      case Resource.SUCCESS:
        thoughts.value.push(...resource.data)
        loading.value = false
        break
      default:
        break
    }
  })
}

async function getFirstThought(){
  await t.getFirstThought((resource: Resource) => {
    switch (resource.status) {
      case Resource.LOADING:
        loading.value = true
        break
      case Resource.ERROR:
        error.value = true
        loading.value = false
        break
      case Resource.SUCCESS:
        firstThought.value = {...resource.data[0]}
        loading.value = false
        break
      default:
        break
    }
  })
}

async function getLastThought(){
  await t.getLastThought((resource: Resource) => {
    switch (resource.status) {
      case Resource.LOADING:
        loading.value = true
        break
      case Resource.ERROR:
        error.value = true
        loading.value = false
        break
      case Resource.SUCCESS:
        lastThought.value = resource.data[0]
        loading.value = false
        break
      default:
        break
    }
  })
}

async function getNextThoughts(){
  await t.getNextThoughts((resource: Resource) => {
    switch (resource.status) {
      case Resource.LOADING:
        loading.value = true
        break
      case Resource.ERROR:
        error.value = true
        loading.value = false
        break
      case Resource.SUCCESS:
        thoughts.value = [...resource.data]
        checkButton()
        loading.value = false
        break
      default:
        break
    }
  })
}

async function getBackThoughts(){
  await t.getBackThoughts((resource: Resource) => {
    switch (resource.status) {
      case Resource.LOADING:
        loading.value = true
        break
      case Resource.ERROR:
        error.value = true
        loading.value = false
        break
      case Resource.SUCCESS:
        thoughts.value = [...resource.data]
        checkButton()
        loading.value = false
        break
      default:
        break
    }
  })
}

onMounted(async() => {
  await getThoughts()
  await getFirstThought()
  await getLastThought()
  checkButton()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Error obteniendo los pensamientos! "))
      : _createCommentVNode("", true),
    (thoughts.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        (showBackButton.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "button btn mb-5",
              onClick: getBackThoughts
            }, "Atrás"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        (showNextButton.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "button btn mb-5",
              onClick: getNextThoughts
            }, "Siguiente"))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(ThoughtComponent, { thoughts: thoughts.value }, null, 8, ["thoughts"]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        (showBackButton.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "button btn mb-5",
              onClick: getBackThoughts
            }, "Atrás"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_13, [
        (showNextButton.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "button btn mb-5",
              onClick: getNextThoughts
            }, "Siguiente"))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})